<div class="wrapper">
    <main class="middle-content">
        <div class="page_title_block">
            <h1 class="page_title">FAQs / Add</h1>
        </div>
        <div class="content-section">
            <div class="order-view max-WT setting-page">
                <div class="add-store-block input-style mb20 ">
                    <form [formGroup]="form">
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12">
                                <label class="mt20 my-4">Question : </label>
                                <input type="text" class="form-control" placeholder="Type your question"
                                    formControlName="question" maxlength="200"
                                    (keypress)="mainService.preventSpace($event)">
                                @if(form.get('question')?.hasError('required') && form.get('question')?.dirty){
                                <div class="text-danger">
                                    *Question is required.
                                </div>
                                }
                            </div>
                        </div>
                        <div class="form-group row align-items-baseline">
                            <div class="col-md-12">
                                <label class="mt20 my-4">Answer:</label>
                                <textarea class="form-control" formControlName="answer" placeholder="Type your answer"
                                    name="" id="" cols="30" rows="5" maxlength="512"
                                    (keypress)="mainService.preventSpace($event)"></textarea>
                                @if(form.get('answer')?.hasError('required') && form.get('answer')?.dirty){
                                <div class="text-danger">
                                    *Message is required.
                                </div>
                                }
                            </div>
                        </div>
                    </form>
                </div>
                <div class="text-center mt-3">
                    <button class="btn btn-large  max-WT-150 btn-theme" [disabled]="form.invalid"
                        (click)="addFaq()">Add</button>
                </div>
            </div>
        </div>
    </main>
</div>